<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header">
                            Team Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                <v-row class="pa-2">
                                    <v-col cols="12">

                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="department_id.value.value"
                                            :items="getHrmDepartmentList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            @update:modelValue="onDepartmentChange"
                                            :error-messages="department_id.errorMessage.value"
                                            autocomplete="off"
                                            :loading="deparment_loading"
                                            clearable
                                        >
                                            <template #label>
                                            Department
                                            <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-text-field
                                            label="Team Name"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="team_name.value.value"
                                            :error-messages="team_name.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                            Team Name
                                            <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-text-field>

                                    </v-col>
                                </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header">
                                Team Members
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                <v-row class="pt-2 justify-center">
                                    <v-col cols="8">
                                        <v-autocomplete
                                        label="Search Employee Name"
                                        variant="outlined"
                                        density="compact"
                                        bg-color="grey-lighten-4"
                                        v-model="employee_id.value.value"
                                        :items="getHrmEmployeeList"
                                        :item-title="(item) => `${item.name}`"
                                        item-value="id"
                                        :error-messages="employee_id.errorMessage.value"
                                        autocomplete="off"
                                        @update:model-value="addEmployee"
                                        @keydown.enter="addEmployee"
                                        clearable
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="1">
                                        <v-btn class="bg-primary" @click="addEmployee">ADD</v-btn>
                                    </v-col>
                                </v-row>

                                <!-- Cart Table -->
                                <v-row class="pt-0">
                                    <v-col cols="12">
                                        <v-table
                                        density="compact"
                                        :loading="loading"
                                        fixed-header
                                        class="table-dotted-border-bottom"
                                        style="height: 40vh; overflow-y: scroll"
                                        >
                                            <thead>
                                                <tr>
                                                    <th class="text-center">SL</th>
                                                    <th class="text-left" style="width: 30%">
                                                    Name
                                                    </th>
                                                    <th class="text-left" style="width: 20%">
                                                    Code
                                                    </th>
                                                    <th class="text-center" style="width: 25%">
                                                    Designation
                                                    </th>
                                                    <!-- <th class="text-center" style="width: 15%">
                                                    Convert Qty
                                                    </th> -->
                                                    <th class="text-center" style="width: 20%">
                                                    Employee Type
                                                    </th>
                                                    <th class="text-center" style="width: 15%">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                v-for="(item, index) in cart"
                                                v-if="cart.length > 0"
                                                :key="index"
                                                >
                                                    <td class="text-center py-1">{{ index + 1 }}</td>
                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.name }}
                                                    </td>
                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.code }}
                                                    </td>

                                                    <td class="text-center py-1">
                                                        {{ item.designation }}
                                                    </td>
                                                    <td class="text-center py-1">
                                                        {{ item.employee_type }}    
                                                    </td>
                                                    <td class="text-center py-1">
                                                        <v-icon
                                                            size="small"
                                                            color="red"
                                                            class="delete-button"
                                                            @click="removeFromCart(index)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                    </td>
                                                </tr>

                                                <tr v-else-if="loading == true">
                                                    <td colspan="6" class="text-center">
                                                        <v-skeleton-loader
                                                            type="heading"
                                                            :loading="loading"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr v-else>
                                                    <td colspan="6" class="text-center text-red">
                                                        You have no item
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                    </v-col>
                                </v-row>
                                <!-- Close Cart Table -->

                                <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                            <v-col cols="8">
                                                <v-textarea
                                                label="Description"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="remarks.value.value"
                                                :error-messages="remarks.errorMessage.value"
                                                autocomplete="off"
                                                rows="3"
                                                clearable
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="4">
                                                <v-layout class="justify-end">
                                                    <v-btn
                                                        class="bg-grey-darken-1 me-2"
                                                        variant="flat"
                                                        @click="submitForm(0)"
                                                        >DRAFT</v-btn
                                                    >
                                                    <v-btn
                                                        class="bg-primary"
                                                        variant="flat"
                                                        @click="submitForm(1)"
                                                        >POST</v-btn
                                                    >
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
export default {
    components: {},
    data: () => ({
        panel: [0],
        panel2: [0],
        loading: false,
        errorMessages: "",
        visible: false,
        search: "",
        deparment_loading: false,
        employee_loading: false,
        cart: [],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getHrmDepartmentList.length === 0) {
            this.deparment_loading = true;
            this.$store.dispatch("getHrmDepartmentList").then((response) => {
                this.deparment_loading = false;
            });
        }
        if (this.$store.getters.getHrmEmployeeList.length === 0) {
            this.employee_loading = true;
            this.$store.dispatch("getHrmEmployeeList").then((response) => {
                this.employee_loading = false;
            });
        }
    },
    computed: {
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getHrmEmployeeList() {
            return this.$store.getters.getHrmEmployeeList;
        },
    },
    methods: {
        async onDepartmentChange(selectedId) {
            if (!selectedId) {
                this.department_id.value.value = null;
                return;
            }

            try {
                const data = await this.$store.dispatch("getHrmEmployeeList", { params: { department_id: selectedId } });
            } catch (error) {
                console.error("Failed to load requisition data:", error);
            }
        },
        addEmployee() {
            const selectedEmployeeId = this.employee_id.value?.value;
            if (!selectedEmployeeId) {
                toast.error("Please select a Employee");
                this.cartReset();
                return false;
            }

            const cartInd = this.cart.findIndex(
                (p) => p.employee_id === selectedEmployeeId
            );

            if (cartInd > -1) {
                toast.error("Employee already added in List");
                this.cartReset();
                return false;
            }

            const employeeMap = this.getHrmEmployeeList.find(item => item.id == selectedEmployeeId);

            const item = {
                employee_id: selectedEmployeeId,
                name: employeeMap?.name || '',
                code: employeeMap?.code || '',
                designation: employeeMap?.designation?.name || '',
                employee_type: employeeMap?.employee_type?.name || '',
                
            };

            this.cart.push(item);
            this.$nextTick(() => {
                this.cartReset();
            });
        },

        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },
        cartReset() {
            this.employee_id.value.value = null;
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                team_name: yup.string().min(3).max(150).required().label("Team Name"),
                department_id: yup.string().required().label("Department Name"),
            }),
        });

        const employee_id = useField('employee_id');
        const team_member_master_id = useField("team_member_master_id");
        const team_name = useField("team_name");
        const department_id = useField("department_id");
        const team_members = useField("team_members");
        const remarks = useField("remarks");
        
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();
        const currentStatus = ref(0);
        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            const employeeIds = cart.value.map(item => item.employee_id);
            
            values.team_members = employeeIds;

            if(values.team_members.length === 0) {
                toast.error("Team member is required.");
                return false;
            }

            store
                .dispatch("saveUpdateSalesTeam", values)
                .then((response) => {
                    resetForm();
                    buttonText.value = "Save";
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "sales-team-list" });
                    }, 2000);
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });

        return {
            submitForm,
            submit,

            team_member_master_id,
            team_name,
            department_id,
            team_members,
            employee_id,

            remarks,
            cart,
            errorMessages,
            buttonText,
            loading,
        };
    },

    mounted() {
        this.employee_id.value.value = null;

        if(this.$store.getters.getEditingSalesTeams){
            this.$store.commit("SET_LOADING",{ color: "primary" });
            const data = this.$store.getters.getEditingSalesTeams;
            this.team_member_master_id.value.value = data.id;
            this.department_id.value.value = data.department_id;
            this.isEntryMode = false;
            this.team_name.value.value = data.team_name;
    
            if (data.team_members && data.team_members.length > 0) {
                this.cart = data.team_members.map(member => {
                const emp = member.employee || {};
                    return {
                        employee_id: member.employee_id,
                        name: emp.name || '',
                        code: emp.code || '',
                        designation: emp.designation?.name || '',
                        employee_type: emp.employee_type?.name || '',
                    };
                });
                this.$store.commit("UNSET_LOADING");
            } else {
                this.cart = [];
                
            }
        }else{
            this.$store.commit("setEditingSalesTeams", null);
        }

    },
    beforeUnmount() {
        this.$store.commit("setEditingSalesTeams", null);
    },

};
</script>
